/** TODO: Delete when migrating apply */
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { TextField } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputBankName = () => (
  <ValidatedTextField
    name="bankName"
    control={useFormContext().control}
    helperText="Example: Chase, Wells Fargo, etc."
    rules={{
      required: 'This field is required.',
    }}
  >
    <TextField fullWidth label="Bank Name" />
  </ValidatedTextField>
);

export default InputBankName;
